import { render, staticRenderFns } from "./TotalPointsPrice.vue?vue&type=template&id=ab6cb9e2&"
import script from "./TotalPointsPrice.vue?vue&type=script&lang=js&"
export * from "./TotalPointsPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports